import axios from "axios";
import { useContext, useState } from "react";
import { useRecoilValue } from "recoil";
import { BACKEND_URL, BoUserIdAtom } from "src/Atoms";
import { PathContext } from "src/v1/context/PathTracker";

const LOGGING_URL = `${BACKEND_URL}/apiOpen/b2c/logging`;

export const useLogging = () => {
  const userId = useRecoilValue(BoUserIdAtom);
  const [cachedIP, setCachedIP] = useState<string | null>(null);
  const { getPreviousPath } = useContext(PathContext);
  const getClientIP = async () => {
    // Return cached IP if available
    if (cachedIP) return cachedIP;

    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      setCachedIP(data.ip); // Cache the IP
      return data.ip;
    } catch (error) {
      console.error("Error fetching IP:", error);
      return "unknown";
    }
  };

  // 두 로그 함수가 동일한 페이로드를 만들도록 한 곳에서 생성
  const buildLogData = (ip: string, info: any) => ({
    ip,
    userId: userId || "anonymous",
    info,
    createdAt: new Date().toISOString(),
  });

  const logEvent = async (info: any = {}) => {
    const ip = await getClientIP();
    axios.post(LOGGING_URL, buildLogData(ip, info));
  };

  // 페이지 이탈 직전에도 전송이 보장되는 로그 (리다이렉트 직전용).
  // keepalive 옵션 덕분에 페이지가 닫혀도 요청이 끝까지 전송된다.
  // (sendBeacon은 application/json + 크로스도메인 제약이 있어 keepalive fetch 사용)
  const logEventBeacon = (info: any = {}) => {
    // 클라이언트 IP는 백엔드가 요청에서 보강 가능하므로, 없으면 "unknown"
    fetch(LOGGING_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(buildLogData(cachedIP || "unknown", info)),
      keepalive: true,
    }).catch(() => {});
  };

  return { logEvent, logEventBeacon, getPreviousPath };
};
